export const styles = {
  wrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '34px 54px',
    textAlign: 'center',
    width: '360px',
  },
  line: {
    width: '2px',
    height: '30px',
    backgroundColor: 'rgba(0, 0, 0, .2)',
  },
}
